import config from '../../config/app';
import { providers } from '../../const/providers';



export const isFabros = config.x_provider === providers.FABROS;

export const isXFLOW = config.x_provider === providers.XFLOW;

